export default "__VITE_ASSET__D2AOD8QE__"